import React, { Component } from "react"
import { browserHistory, Router } from "react-router"
import { Spinner } from "elemental"
import routes from "./routes.js"
import app from "./app.controller"
import shop from "./shop/shop"
import onBarcode from "./shop/onBarcode"

// Set up event handler to produce text for the window focus event
window.addEventListener( "focus", function ( event ) {
  console.log( "GOT FOCUS" )
  shop.cart.get()
}, false );


window.shop = shop // DEBUG
class App extends Component {
  state = { ready: false, readyFrontPage: false, readyWhoAmI: false, readyConfig: false }
  
  constructor() {
    super()
    shop.events.logout.add( () => {
      shop.loadCategories()
      // TODO: Move to router v4 and create better auth checking
      // if ( current.pathname != "/login" && current.pathname != "/customer_registration" && current.pathname != "/reset_password/" && current.pathname != "/reset_password" ) browserHistory.push( "/login" )
    } )
    
    shop.events.login.add( () => {
      shop.loadCategories()
      // TODO: Move to router v4 and create better auth checking
      // if ( current.pathname != "/login" && current.pathname != "/customer_registration" && current.pathname != "/reset_password/" && current.pathname != "/reset_password" ) browserHistory.push( "/login" )
    } )
    
    shop.getConfig()
      .then( () => shop.loadCategories() )
      .then( () => this.setState( { readyConfig: true } ) )
      .catch( err => this.handleError( err ) )
    
    shop.getFrontPage()
      .then( () => {
        this.setState( { readyFrontPage: true } )
      } )
      .catch( err => this.handleError( err ) )
    
    shop.whoami()
      .then( () => {
        this.setState( { readyWhoAmI: true } )
      } )
      .catch( err => this.handleError( err ) )
    
    app.language.changed.add( this.handleLanguageChange )
  }
  
  handleLanguageChange = () => {
    this.forceUpdate()
  }
  
  handleError = error => {
    alert( error )
    this.setState( { error } )
  }
  
  componentDidMount() {
    this.historyUnlisten = browserHistory.listen( () => this.scrollToTop() )
    this.historyUnlistenSession = browserHistory.listen( ( location ) => this.checkSession( location ) )
    this.historyUnlistenSession = browserHistory.listen( ( location ) => {
      if ( window.ga ) {
        window.ga( 'set', 'page', location.pathname + location.search );
        window.ga( 'send', 'pageview' );
      }
      console.log( "=== PAGE", location.pathname + location.search )
    } )
    onBarcode( this.goSearch )
  }
  
  goSearch = ( barcode ) => {
    console.log( `goSearch:Barcode`, barcode )
    browserHistory.push( `/ean/${barcode}` )
  }
  
  componentWillUnmount() {
    this.historyUnlisten()
    this.historyUnlistenSession()
  }
  
  checkSession( location ) {
    if ( location.state && location.state.access === false ) {
      shop.whoami()
        .then( () => {
          this.setState( { ready: true } )
        } )
    }
  }
  
  scrollToTop() {
    window.scrollTo( 0, 0 )
  }
  
  render() {
    const { readyWhoAmI, readyFrontPage, readyConfig, error } = this.state
    if ( error ) return <div className="flex items-center justify-center vh-75">
      <div>
        <p>
          Der Shop ist zur Zeit nicht erreichbar. Wir sind gleich wieder für Sie da.
        </p>
      </div>
    </div>
    if ( !readyWhoAmI || !readyFrontPage || !readyConfig ) {
      return <div className="flex items-center justify-center vh-75"><Spinner
        size="lg"/></div>
    }
    return (
      <Router routes={routes} history={browserHistory}/>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js